import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import ProjectCard from "@/components/feature/ProjectCard";
import ProjectCarousel3D from "@/components/feature/ProjectCarousel3D";
import { useSiteContent } from "@/context/SiteContentContext";

const filters = [
  "Todos",
  "Web",
  "Sistemas",
  "Aplicaciones",
  "Comercio electrónico",
  "Automatización",
  "Empresarial",
];

export default function Projects() {
  const { projects, sections, settings } = useSiteContent();
  const content = sections.proyectos || {};
  const [active, setActive] = useState("Todos");
  const [view, setView] = useState<"3d" | "grid">("3d");
  const animated = settings.animations_enabled !== false;

  const filtered =
    active === "Todos"
      ? projects
      : projects.filter((p) => (p.categorias ?? []).includes(active));

  return (
    <section
      id="proyectos"
      className="relative py-20 md:py-28 bg-background-100 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Portafolio"
          title={String(content.title || "Proyectos que hemos construido")}
          subtitle={String(
            content.subtitle ||
              "Una selección de soluciones digitales desarrolladas para diferentes tipos de negocios."
          )}
        />

        <div className="mt-10 flex flex-col items-center gap-5">
          <div className="flex flex-wrap justify-center gap-2">
            {filters.map((filter) => (
              <button
                key={filter}
                type="button"
                onClick={() => setActive(filter)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  active === filter
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-50 text-foreground-600 border border-background-200 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {filter}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200">
            <button
              type="button"
              onClick={() => setView("3d")}
              className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                view === "3d"
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              <i className="ri-eye-line text-base" />
              Vista 3D
            </button>
            <button
              type="button"
              onClick={() => setView("grid")}
              className={`flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                view === "grid"
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              <i className="ri-layout-grid-line text-base" />
              Cuadrícula
            </button>
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="mt-16 text-center text-foreground-500">
            <p>No hay proyectos en esta categoría todavía.</p>
          </div>
        ) : view === "3d" ? (
          <div className="mt-8">
            <ProjectCarousel3D projects={filtered} animated={animated} />
          </div>
        ) : (
          <div
            key={active}
            className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          >
            {filtered.map((project, i) => (
              <Reveal key={project.id} delay={(i % 3) * 80} variant="scale">
                <ProjectCard project={project} />
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}